module.exports = __webpack_public_path__ + "static/media/star-grey.879dd509.png";